export { default } from "ember-truth-helpers/helpers/not";
